export default "__VITE_ASSET__b7dac798__"